import getters from "./getters.js";
import actions from "./actions.js";
import mutations from "./mutations.js";

// Detects other browser tabs that are active on the operations page at the same time,
// so the page can warn the user about working in several queues at once.
export default {
  namespaced: true,
  state() {
    return {
      // tabId -> time of the last message from that tab
      otherTabs: {},
      warningDismissed: false
    };
  },
  getters,
  actions,
  mutations
};
